import TweenMax from 'gsap'

let cursor = $('#js-cursor'),
  width = 24,
  delay = 3,
  mouseX = 0,
  mouseY = 0,
  posX = 0,
  posY = 0

TweenMax.to({}, 0.001, {
  repeat: -1,
  onRepeat: function() {
    posX += (mouseX - posX) / delay
    posY += (mouseY - posY) / delay

    TweenMax.set(cursor, {
      css: {
        left: posX - width / 2,
        top: posY - width / 2
      }
    })
  }
})

$(document).on('mousemove', function(e) {
  mouseX = e.pageX
  mouseY = e.pageY
})

$('a:not([href^="tel:"]),button,label,input[type="submit"]').on({
  mouseenter: function() {
    cursor.addClass('is-active')
  },
  mouseleave: function() {
    cursor.removeClass('is-active')
  }
})
